import React from 'react';
import GardenWallNode from '../formNodes/GardenWallNode';

const WorkflowTemplate = ({ workflowType, status }) => {
  // console.log(workflowType);
  switch (workflowType) {
    case 'type2':
      return <GardenWallNode status={status} />;
    default:
      return <div>Invalid workflow name</div>;
  }
};

export default WorkflowTemplate;
